import _ from 'lodash';
/**
 * 深度优先遍历
 * @param node 树根节点或节点列表
 * @param childrenKey 子节点列表 key
 * @param callback 回调函数
 */
export function treeForEach(node, childrenKey, callback) {
    if (node) {
        const iterator = (nodes, level, parentPath) => {
            let ifContinue;
            _.forEach(nodes, node => {
                // 支持提前结束, 如果返回 false 则提前结束
                ifContinue = callback(node, level, parentPath);
                if (ifContinue === false)
                    return false;
                const children = node[childrenKey];
                if (children && children.length) {
                    ifContinue = iterator(children, level + 1, _.concat(parentPath, node));
                    return ifContinue;
                }
            });
            return ifContinue;
        };
        const nodes = [];
        iterator(nodes.concat(node), 1, []);
    }
}
/**
 * 从树中按深度优先遍历查找节点
 * @param node 树根节点或节点列表
 * @param childrenKey 子节点列表 key
 * @param predicate 查找条件
 */
export function treeFind(node, childrenKey, predicate) {
    let rt;
    treeForEach(node, childrenKey, (node, level) => {
        if (predicate(node, level)) {
            rt = node;
            return false;
        }
    });
    return rt;
}
